import React from "react";
import throttle from "lodash.throttle";
import ImageGoal from "../img/soccerball.svg";
import ImageWhistle from "../img/whistle.svg";
import ImageYellowCard from "../img/yellowcard.png";
import ImageRedCard from "../img/redcard.png";

export default class StreamEventTimeline extends React.Component {
    constructor (props) {
        super(props);

        this.eventToImg = {
            'goal': ImageGoal,
            'start phase': ImageWhistle,
            'end phase': ImageWhistle,
            'end of game': ImageWhistle,
            'yellow card': ImageYellowCard,
            'red card': ImageRedCard,
        };

        this.onSeek = this.onSeek.bind(this);
        // Adding a throttled version of the seek function as well
        // Improves performance and user experience when dragging (touch)
        this.onSeekThrottled = throttle(this.onSeek.bind(this), 150);

        this.currentPlaybackRate = 1;
    }

    timeToOffset(time) {
        return Math.max(0, time - this.props.streamStart.getTime()) / 1000;
    }

    getDelimitingOffsets() {

        let {gameStart, gameFinished} = this.props;

        const startTime = gameStart.getTime();
        let endTime;

        if (gameFinished) {
            endTime = this.props.gameFinished.getTime();
        } else {
            endTime = startTime + 3 * 3600 * 1000; // Set upper limit of 3h after match start (or capped at duration)
        }

        const justBeforeStart = Math.max(this.timeToOffset(startTime) - 300 || 0, 0);
        const afterEnd = Math.min(this.timeToOffset(endTime) + 300 || this.props.duration, this.props.duration);
        return {
            startOffset: justBeforeStart <= this.props.duration ? justBeforeStart : 0,
            endOffset: afterEnd
        };
    }

    offsetToStylePos (offset) {
        const { startOffset, endOffset } = this.getDelimitingOffsets();
        const clippedDuration = endOffset - startOffset;
        return "" + Math.min(100, 100 * (offset - startOffset) / clippedDuration) + "%";
    }

    onSeek (pageX) {
        const pixelPosition = pageX - this.timelineElement.getBoundingClientRect().left;
        const percentage = Math.min(1, Math.max(0, (pixelPosition / this.timelineElement.offsetWidth)));
        const { startOffset, endOffset } = this.getDelimitingOffsets();
        const clippedDuration = endOffset - startOffset;
        const time = startOffset + clippedDuration * percentage;

        console.log('Seeking to: ' + time);
        this.props.onSeek(time);

        return time;
    }

    eventColor (event) {
        if(event.tag.team !== undefined && event.tag.team.id !== undefined) {
            if(event.tag.team.id === this.props.homeTeam.id) {
                return this.props.homeTeamColor;
            }
            if(event.tag.team.id === this.props.visitingTeam.id) {
                return this.props.visitingTeamColor;
            }
        }
        return "white";
    }

    render () {
        const { startOffset, endOffset } = this.getDelimitingOffsets();

        const buffers = this.props.bufferRanges
            .filter((buffer) => buffer.start >= startOffset
                && buffer.end <= endOffset)
            .map((buffer) => (
            <div key={buffer.start} className="timeline-buffer" style={{
                left: this.offsetToStylePos(buffer.start),
                width: this.offsetToStylePos(buffer.end - buffer.start),
            }} />
        ));

        const markedEvents = ['goal', 'start phase', 'end phase', 'end of game', 'yellow card', 'red card'];

        let eventMarkers = this.props.events
            .filter((event) => event
                && event.tag
                && markedEvents.includes(event.tag.action)
                && event.timestamp >= this.props.streamStart.getTime() + startOffset*1000
                && event.timestamp <= this.props.streamStart.getTime() + endOffset*1000)
            .map((event) => (
            <div key={event.id} className="timeline-marker"
                onClick={(clickEvent) => {
                    clickEvent.stopPropagation();
                    this.props.onSeek(this.timeToOffset(event.playlist.recordingTime));
                    return false;
                }}
                style={{
                    left: this.offsetToStylePos(this.timeToOffset(event.timestamp))}}>
                <div style={{
                    backgroundImage: "url(" + this.eventToImg[event.tag.action] + ")",
                    backgroundSize: "cover",
                    borderColor: this.eventColor(event) }} />
            </div>
        ));

        return (
            <div className="stream-timeline first-level-timeline"
                onContextMenu={(ev) => ev.preventDefault()}
                onClick={(ev) => this.onSeek(ev.pageX)}
                ref={(timeline) => this.timelineElement = timeline}>
                { buffers }
                <div className="timeline-progress" style={{width: this.offsetToStylePos(this.props.progress)}} />
                <div className="timeline-background" />
                { eventMarkers }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/StreamEventTimeline.js